var map = {
	"./acf-migration-example/block.js": 5352,
	"./blog-posts/block.js": 4140,
	"./case-studies-promo/block.js": 6160,
	"./content-grid/block.js": 9582,
	"./content-image/block.js": 113,
	"./content-title/block.js": 5322,
	"./content-video/block.js": 8047,
	"./fifty-fifty/block.js": 8885,
	"./four-column-intro/block.js": 7366,
	"./generic-text/block.js": 149,
	"./hero/block.js": 5950,
	"./image-gallery/block.js": 2562,
	"./logo-scroller/block.js": 660,
	"./main-cta/block.js": 1440,
	"./nadez-test/block.js": 1973,
	"./numbered-intro/block.js": 2725,
	"./page-hero/block.js": 666,
	"./raw-html/block.js": 918,
	"./spacer/block.js": 2646,
	"./swiper-example/block.js": 5305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5907;